import Layout from '@/components/feature/Layout';
import HomeHero from './components/HomeHero';
import HomeFeatures from './components/HomeFeatures';
import HomeStats from './components/HomeStats';
import HomeDownload from './components/HomeDownload';
import HomeCategories from './components/HomeCategories';
import HomeArticles from './components/HomeArticles';
import HomeFAQ from './components/HomeFAQ';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'PG国际下载008',
    url: 'https://pgjixz008.com/',
    description: 'PG国际下载008官方正版，提供最新版本极速安装包，支持iOS与Android全平台下载，安全无毒，一键安装，畅享PG国际008全部功能与游戏体验。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://pgjixz008.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'PG国际下载008',
    url: 'https://pgjixz008.com/',
    description: 'PG国际008官方正版下载平台',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'service@pgjixz008.com',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
  };

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'PG国际下载008 - 官方正版安装包极速下载',
    description: 'PG国际下载008官方正版，提供最新版本极速安装包，支持iOS与Android全平台下载，安全无毒，一键安装。',
    url: 'https://pgjixz008.com/',
    isPartOf: { '@type': 'WebSite', name: 'PG国际下载008', url: 'https://pgjixz008.com/' },
  };

  return (
    <Layout>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
      />
      <HomeHero />
      <HomeFeatures />
      <HomeStats />
      <HomeDownload />
      <HomeCategories />
      <HomeArticles />
      <HomeFAQ />
    </Layout>
  );
}